import React, {Component} from 'react'

import {
  FILE_STORAGE
} from '../../../constants'

// import styles
import './gallery.scss'

class Gallery extends Component {

  constructor (props) {
    super(props)
    this.state = {
      loading: []
    }
  }

  renderFile (item, key) {
    // let url = API_BASE + item.ThumbURL
    // let fullUrl = API_BASE + item.FileURL
    let url = FILE_STORAGE + item.ThumbURL
    let fullUrl = FILE_STORAGE + item.FileURL
    console.log('url', url)
    return (
      <div key={key}>
        <a href={fullUrl} data-lightbox='gallery' data-title={item.FileName}><img src={url} /></a>
      </div>
    )
  }

  render () {
    let { loading } = this.state
    for (let j = loading.length; j < this.props.files.length; j++) {
      loading.push(true)
    }

    return (
      <div className='gallery clearfix'>
        {this.props.renderImage !== undefined ? this.props.files.map(this.props.renderImage) : null}
      </div>
    )
  }
}

Gallery.propTypes = {
  renderImage: React.PropTypes.func.isRequired
}

export default Gallery



// WEBPACK FOOTER //
// ./src/app/shared/components/Gallery/index.js